<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <LeituraHotel />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>

<script>
import LeituraHotel from "../Components/Leituras/LeituraHotel.vue";
export default {
  name: "ReadHotel",
  components: {
    LeituraHotel,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>